module.exports = __webpack_public_path__ + "img/intro_2.0e5b3cec.jpeg";